function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SvelteRailsUJS = /*#__PURE__*/function () {
  function SvelteRailsUJS() {
    _classCallCheck(this, SvelteRailsUJS);
  }

  _createClass(SvelteRailsUJS, null, [{
    key: "serverRender",
    value: function serverRender(component_name, props) {
      var requireComponent = require.context('components', true);

      var bundle = requireComponent('./' + component_name)["default"];

      var _bundle$render = bundle.render(props),
          html = _bundle$render.html;

      return html;
    }
  }, {
    key: "start",
    value: function start() {
      SvelteRailsUJS.mountComponents();
      document.addEventListener('DOMContentLoaded', SvelteRailsUJS.mountComponents);
      document.addEventListener('turbolinks:load', SvelteRailsUJS.mountComponents);
    }
  }, {
    key: "mountComponents",
    value: function mountComponents() {
      document.querySelectorAll('[data-svelte-class]:not([data-svelte-initialized])').forEach(SvelteRailsUJS.mountComponent);
    }
  }, {
    key: "mountComponent",
    value: function mountComponent(target) {
      var name = target.dataset.svelteClass;
      var hydrate = !!target.dataset.hydrate;
      var props = {};

      if (target.dataset.svelteProps) {
        props = JSON.parse(target.dataset.svelteProps);
      }

      var requireComponent = require.context('components', true);

      var Component = requireComponent('./' + name)["default"];
      console.debug(Component, {
        target: target,
        props: props,
        hydrate: hydrate
      });
      var component = new Component({
        target: target,
        props: props,
        hydrate: hydrate
      });
      target.dataset.svelteInitialized = true;
    }
  }]);

  return SvelteRailsUJS;
}(); // self.SvelteRailsUJS = SvelteRailsUJS


export default SvelteRailsUJS;